import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {BooleanIndicatorComponent} from "../boolean-indicator/boolean-indicator.component";

@Component({
    selector: 'app-password-validation-display',
    imports: [
        BooleanIndicatorComponent,
    ],
    templateUrl: './password-validation-display.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './password-validation-display.component.scss'
})
export class PasswordValidationDisplayComponent {
  @Input() form!: FormGroup;

  public isActive(field: string, error: string): boolean {
    if (!this.form.controls || !this.form.controls[field]) {
      return false;
    }

    return this.form.controls[field].touched && this.form.controls[field].value && !this.form.controls[field].hasError(error);
  }
}
